import { ProgramLevel } from '@/externals/gyym/user/programs'
import {
  ProgramLevelLabels,
  ProgramGenderLabels,
  ProgramLevelOption,
} from './types'
import { Gender } from '@/externals/gyym'

export { Gender } from '@/externals/gyym'

export enum ViewMode {
  PROGRAMS = 'programs',
  TIMETABLES = 'timetables',
}

export const programLevelLabels: ProgramLevelLabels = {
  [ProgramLevel.ENTRY]: '入門クラス',
  [ProgramLevel.BEGINNER]: '初級クラス',
  [ProgramLevel.INTERMEDIATE]: '中級クラス',
  [ProgramLevel.ADVANCED]: '上級クラス',
}

export const programLevelOptions: ProgramLevelOption[] = [
  { label: '入門', value: ProgramLevel.ENTRY },
  { label: '初級', value: ProgramLevel.BEGINNER },
  { label: '中級', value: ProgramLevel.INTERMEDIATE },
  { label: '上級', value: ProgramLevel.ADVANCED },
]

export const programGenderLabels: ProgramGenderLabels = {
  [Gender.NONE]: '性別制限なし',
  [Gender.MEN]: '男性専用',
  [Gender.WOMEN]: '女性専用',
}

export const cancelDeadline = 3
